module.exports = __webpack_public_path__ + "img/designcomputer.6de6c9c3.jpg";